import React, { useEffect, useRef } from "react";

// Libraries and Packages
import { cubicBezier, motion, useAnimation, useInView } from "framer-motion";

function AnimatedText({ children, delay = 0.5 }) {
  // Ref
  const refText = useRef(null);

  // Framer Motion
  const controlsAnimatedText = useAnimation();

  const isAnimatedTextInView = useInView(refText, {
    once: false,
  });

  // Effect
  useEffect(() => {
    if (isAnimatedTextInView) {
      controlsAnimatedText.start({
        opacity: 1,
        y: 0,
        transition: {
          duration: 1,
          delay: delay,
          ease: cubicBezier[(0.6, 0.01, -0.05, 0.9)],
        },
      });
    }
  }, [isAnimatedTextInView, controlsAnimatedText, delay]);

  return (
    <motion.div
      ref={refText}
      initial={{ opacity: 0, y: 20 }}
      animate={controlsAnimatedText}
    >
      {children}
    </motion.div>
  );
}

export default AnimatedText;
